export const formatter = {
  bookingNo,
  depositNo,
  disbursementNo,
  refundNo,
  orderNo,
  invoiceNo,
  paymentNo,
  formatMoney,
  formatMoneyNumber,
};

function bookingNo(bookingNo) {
  return "B" + String(bookingNo).padStart(10, '0')
}

function depositNo(depositNo) {
  return "D" + String(depositNo).padStart(10, '0')
}

function refundNo(refundNo) {
  return "R" + String(refundNo).padStart(10, '0')
}

function orderNo(orderNo) {
  return "O" + String(orderNo).padStart(10, '0')
}

function invoiceNo(invoiceNo) {
  return "I" + String(invoiceNo).padStart(10, '0')
}

function paymentNo(paymentNo) {
  return "P" + String(paymentNo).padStart(10, '0')
}

function disbursementNo(disbursementNo) {
  return "DI" + String(disbursementNo).padStart(10, '0')
}

function formatMoney(input, locale, precision = 0) {
  if (!input || typeof input !== "number") {
    return input;
  }
  // The constructor was outside the try, so the catch below never ran for the
  // case that actually happens: Intl.NumberFormat throws RangeError on an empty
  // or malformed currency code, and an uncaught throw here takes the whole
  // screen down through React's error boundary. Some disbursements carry no
  // currency at all, so the amount is shown unformatted rather than not at all.
  try {
    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: locale,
      currencyDisplay: "symbol",
      minimumFractionDigits: precision,
    });
    return formatter.format(input);
  } catch (e) {
    return input;
  }
}

function formatMoneyNumber(input, precision = 0) {
  if (!input || typeof input !== "number") {
    return input;
  }
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: precision,
  });
  return formatter.format(input);
}